module.exports = __webpack_public_path__ + "static/header-back-97d47026e1b70a354394ed05d5c183c9.png";